/* Rotating headline for the hero.
 *
 * Types a word out, holds it, deletes it, moves to the next. The alternative —
 * cross-fading whole words — reads as a slideshow of adjectives; typing reads
 * as someone deciding, which is closer to what the sentence is claiming.
 *
 * Anyone who has asked for reduced motion gets the first word, static. The
 * markup already contains that word, so the headline is complete before this
 * file loads and stays complete if it never does.
 */
(function () {
  'use strict';

  var el = document.querySelector('[data-pp-type]');
  if (!el) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var words;
  try { words = JSON.parse(el.dataset.ppType).map(function (w) { return String(w).trim(); }).filter(Boolean); }
  catch (e) { return; }
  if (words.length < 2) return;

  var out = el.querySelector('[data-pp-word]');
  if (!out) return;

  // No width reservation. This used to hold the longest word's width in ch
  // units, but ch is the width of a zero and the headline is set in an italic
  // serif — so the reserved box was far wider than the word inside it and the
  // caret was left stranded to the right of empty space. The rotating word is
  // the last thing on the line, so letting it reflow moves nothing but the
  // caret, which is the point.

  var TYPE = 55, DELETE = 30, HOLD = 1400, BETWEEN = 260;
  var i = 0, ch = words[0].length, deleting = false, timer = null;

  function tick() {
    var word = words[i];
    if (!deleting) {
      ch++;
      if (ch >= word.length) {
        ch = word.length;
        deleting = true;
        out.textContent = word;
        return schedule(HOLD);
      }
    } else {
      ch--;
      if (ch <= 0) {
        ch = 0;
        deleting = false;
        i = (i + 1) % words.length;
        out.textContent = '';
        return schedule(BETWEEN);
      }
    }
    out.textContent = word.slice(0, ch);
    schedule(deleting ? DELETE : TYPE);
  }

  function schedule(ms) { clearTimeout(timer); timer = setTimeout(tick, ms); }

  // Nothing moves until the headline is actually on screen, and it stops again
  // when the tab is hidden — a background timer typing to nobody is just work.
  function start() { schedule(HOLD); }
  function stop() { clearTimeout(timer); }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) start(); else stop();
    }, { threshold: 0.2 }).observe(el);
  } else {
    start();
  }
})();
